import { injectable } from '@wix/typesafe-inversify';
import type { EditorReadyOptions } from '@wix/platform-editor-sdk';
import type { IReadyAppData } from './IReadyAppData';

class UninitializedError extends Error {
  constructor() {
    super('Uninitialized Error');
  }
}

@injectable()
export class ReadyAppData implements IReadyAppData {
  private readyData?: {
    appDefinitionId: string;
    editorReadyOptions: EditorReadyOptions;
  };

  initialize(appDefinitionId: string, editorReadyOptions: EditorReadyOptions) {
    this.readyData = {
      appDefinitionId,
      editorReadyOptions,
    };
  }

  isReady() {
    return Boolean(this.readyData);
  }

  get appDefinitionId() {
    if (!this.readyData) {
      throw new UninitializedError();
    }
    return this.readyData.appDefinitionId;
  }

  get editorReadyOptions() {
    if (!this.readyData) {
      throw new UninitializedError();
    }
    return this.readyData.editorReadyOptions;
  }

  get editorType() {
    return this.editorReadyOptions.origin.type;
  }
}
